"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IChargeMethod_1 = require("../../../models/rates/IChargeMethod");
exports.default = joi_1.default.object({
    chargeType: joi_1.default.string().valid(IChargeMethod_1.ChargeType.Flat).required(),
    countingUnit: joi_1.default.string()
        .valid(IChargeMethod_1.CountingUnit.Location, IChargeMethod_1.CountingUnit.Transaction, IChargeMethod_1.CountingUnit.Qty, IChargeMethod_1.CountingUnit.LineItems, IChargeMethod_1.CountingUnit.Lot, IChargeMethod_1.CountingUnit.SKU)
        .required()
        .id(IChargeMethod_1.ChargeType.Flat),
    calculatedBy: joi_1.default.when('countingUnit', [
        {
            is: IChargeMethod_1.CountingUnit.Location,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.Location),
        },
        {
            is: IChargeMethod_1.CountingUnit.Transaction,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.Transaction),
        },
        {
            is: IChargeMethod_1.CountingUnit.Qty,
            then: joi_1.default.string().valid(IChargeMethod_1.CalculatedBy.Count).id(IChargeMethod_1.CountingUnit.Qty),
        },
        {
            is: IChargeMethod_1.CountingUnit.LineItems,
            then: joi_1.default.string()
                .valid(IChargeMethod_1.CalculatedBy.Count)
                .id(IChargeMethod_1.CountingUnit.LineItems),
        },
        {
            is: IChargeMethod_1.CountingUnit.Lot,
            then: joi_1.default.string().valid(IChargeMethod_1.CalculatedBy.Count).id(IChargeMethod_1.CountingUnit.Lot),
        },
        {
            is: IChargeMethod_1.CountingUnit.SKU,
            then: joi_1.default.string().valid(IChargeMethod_1.CalculatedBy.Count).id(IChargeMethod_1.CountingUnit.SKU),
        },
    ]).required(),
    roundUp: joi_1.default.boolean().optional(),
});
